export * from './move-item-in-array';
export * from './nx-reorder-handle.directive';
export * from './nx-reorder-item.directive';
export { NxReorderListDirective, NxReorderEvent } from './nx-reorder-list.directive';

import { NxReorderHandleDirective } from './nx-reorder-handle.directive';
import { NxReorderItemDirective } from './nx-reorder-item.directive';
import { NxReorderListDirective } from './nx-reorder-list.directive';

/** All reorder directives — spread into a module's declarations and exports. */
export const NX_REORDER_DIRECTIVES = [
  NxReorderListDirective,
  NxReorderItemDirective,
  NxReorderHandleDirective
] as const;
